<div class="blogs header_top" *ngIf="blogs.length > 0">
  <div class="container">
    <div class="header">
      <h4>Blogs</h4>
    </div>
    <div class="row">
      <div *ngFor="let blog of blogs" class="col-lg-4 col-md-4 col-sm-12 blog_content">
        <img *ngIf="blog.image" [src]="apiUrl + '/' + blog.image" alt="Blog Image" class="img-fluid mb-3">
        
        <!-- ✅ Show only headings from description -->
        <div [innerHTML]="extractFirstHeading(blog.description)"></div>

        <button class="pink_bg mt px-4" [routerLink]="['/blog-detail', blog.slug]">
          See More
        </button>
      </div>
    </div>
  </div>
</div>
